import {Directive, ElementRef, AfterViewInit} from '@angular/core';
import {Input} from "@angular/core";
declare var $: any;

/**
 * truncates the display for table cell answers to prevent the wrapping and shows full answer in a popup.
 * the popup is initialised every time a table cell is de-selected
 */
@Directive({
    selector: '[appTooltip]',
    standalone: false
})
export class TooltipDirective implements AfterViewInit {

  @Input() content: string;
  @Input() showOnTruncate: boolean = false;
  

  constructor(private el: ElementRef) {
  }

  ngAfterViewInit() {
    if (this.content && (!this.showOnTruncate || this.el.nativeElement.scrollWidth > this.el.nativeElement.clientWidth)) {
      setTimeout(() => this.initPopup(this.content));
    }
  }

  private initPopup(content) {
    $(this.el.nativeElement).popup({
      content: content,
      position: "top center",
      inline: false,
      variation: "inverted",
    });
  };


}
